import './nested-interaction-button.css';
export var headerDragAndDropCSS = {dragging:'_12gcd31-2-0-1',enabled:'_12gcd32-2-0-1',inactive:'_12gcd33-2-0-1'};
export var nestedInteractionButtonCSS = '_12gcd30-2-0-1';